module.exports = __webpack_public_path__ + "static/media/test2.1a25a845.jpg";